module.exports = __webpack_public_path__ + "img/analysisReport.f44aff74.png";